import type { RefObject } from 'react';
import { ArrowsPointingInIcon, ArrowsPointingOutIcon } from '@heroicons/react/24/outline';

const ENTER_CLASS =
    'grid h-8 w-8 shrink-0 place-items-center rounded-lg text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent';
const EXIT_CLASS =
    'inline-flex h-8 shrink-0 items-center gap-1.5 rounded-lg px-2.5 text-[13px] font-semibold text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-400';

interface GalleryFullscreenToggleProps {
    buttonRef?: RefObject<HTMLButtonElement>;
    fullscreen: boolean;
    disabled: boolean;
    label: string;
    onToggle: () => void;
}

export function GalleryFullscreenToggle({
    buttonRef,
    fullscreen,
    disabled,
    label,
    onToggle
}: GalleryFullscreenToggleProps) {
    if (fullscreen) {
        return (
            <button ref={buttonRef} type="button" onClick={onToggle} className={EXIT_CLASS}>
                <ArrowsPointingInIcon className="h-4 w-4" aria-hidden="true" />
                Exit full screen
            </button>
        );
    }
    return (
        <button
            ref={buttonRef}
            type="button"
            onClick={onToggle}
            disabled={disabled}
            aria-label={`Show ${label.toLowerCase()} full screen`}
            title="Full screen"
            className={ENTER_CLASS}
        >
            <ArrowsPointingOutIcon className="h-4 w-4" aria-hidden="true" />
        </button>
    );
}
